import { Configuration, ConsumerLoanApplicationApi } from "../lib-api";
import { ApplicationState } from "../models/ApplicationState";
import * as Sentry from '@sentry/react';

export const ApiConfiguration = new Configuration({
  //basePath: window.location.protocol + '//' + window.location.host,
  basePath: ''
});

export async function saveStateRemote(state: ApplicationState) : Promise<void> {

  if(!state.applicationId)
  {
    try {
      throw new Error("state.applicationId is undefined");
    } catch (error) {
      //Sentry.captureException(error);
    }
    alert("Der er sket en fejl. Prøv venligst igen.");
    window.location.href = '/';
    return;
  }
  
  const api = new ConsumerLoanApplicationApi(ApiConfiguration);
  await api.saveApplicationProgress({ body: state });
}

export async function submitApplication(applicationId: string) : Promise<void> {
  const api = new ConsumerLoanApplicationApi(ApiConfiguration);
  await api.submitApplication({ body: { applicationId } });
}

export async function initializeApplication(amount: number, time: number, name: string, mobile: string, email: string ) : Promise<string | undefined> {
  const api = new ConsumerLoanApplicationApi(ApiConfiguration);
  var response = await api.initializeApplicationNEW({ body: { amount, time, name, mobile, email  } });
  return response.applicationId;
}